import React from 'react';

import {
  StyledButton,
  StyledDefaultTemplateError,
  StyledDefaultTemplateErrorMessage,
  StyledError,
  StyledHeader,
  StyledSubHeader,
} from './styles';

const DefaultTemplateError = () => (
  <StyledDefaultTemplateError>
    <StyledDefaultTemplateErrorMessage>
      <StyledError />
      <StyledHeader>Unable to Load</StyledHeader>
      <StyledSubHeader>There was an issue, sorry! Try again.</StyledSubHeader>
      <StyledButton
        data-test-id="44376942-79fe-4eb0-9207-47231aa07091"
        onClick={() => window.location.reload()}
        variant="ghost"
      >
        Reload
      </StyledButton>
    </StyledDefaultTemplateErrorMessage>
  </StyledDefaultTemplateError>
);

export default DefaultTemplateError;
